import { render, staticRenderFns } from "./ModalDetalheRegistro.vue?vue&type=template&id=9b852f84&scoped=true"
import script from "./ModalDetalheRegistro.vue?vue&type=script&lang=js"
export * from "./ModalDetalheRegistro.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalheRegistro.vue?vue&type=style&index=0&id=9b852f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b852f84",
  null
  
)

export default component.exports